"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.DateTimePicker = void 0;
var react_datepicker_1 = __importStar(require("react-datepicker"));
var cs_1 = __importDefault(require("date-fns/locale/cs"));
var de_1 = __importDefault(require("date-fns/locale/de"));
var es_1 = __importDefault(require("date-fns/locale/es"));
var fr_1 = __importDefault(require("date-fns/locale/fr"));
var ja_1 = __importDefault(require("date-fns/locale/ja"));
var pl_1 = __importDefault(require("date-fns/locale/pl"));
var pt_1 = __importDefault(require("date-fns/locale/pt"));
var zh_CN_1 = __importDefault(require("date-fns/locale/zh-CN"));
var classnames_1 = __importDefault(require("classnames"));
var date_fns_1 = require("date-fns");
var react_1 = __importStar(require("react"));
require("react-datepicker/dist/react-datepicker.css");
var Form_1 = require("../Form");
require("./DateTimePicker.css");
(0, react_datepicker_1.registerLocale)('cs', cs_1["default"]);
(0, react_datepicker_1.registerLocale)('de', de_1["default"]);
(0, react_datepicker_1.registerLocale)('es', es_1["default"]);
(0, react_datepicker_1.registerLocale)('fr', fr_1["default"]);
(0, react_datepicker_1.registerLocale)('jp', ja_1["default"]);
(0, react_datepicker_1.registerLocale)('pl', pl_1["default"]);
(0, react_datepicker_1.registerLocale)('pt', pt_1["default"]);
(0, react_datepicker_1.registerLocale)('zh', zh_CN_1["default"]);
var MIN_DATE = (0, date_fns_1.startOfDay)(new Date(-864000000000000 + 1));
var MAX_DATE = (0, date_fns_1.endOfDay)(new Date(864000000000000 - 1));
var DateTimePicker = function (_a) {
    var className = _a.className, id = _a.id, selected = _a.selected, error = _a.error, _b = _a.onChange, onChange = _b === void 0 ? function () { } : _b, _c = _a.dateFormat, dateFormat = _c === void 0 ? 'Pp' : _c, _d = _a.timeFormat, timeFormat = _d === void 0 ? 'h:mm aa' : _d, _e = _a.isClearable, isClearable = _e === void 0 ? false : _e, _f = _a.minDateTime, minDateTime = _f === void 0 ? MIN_DATE : _f, _g = _a.minDate, minDate = _g === void 0 ? minDateTime : _g, _h = _a.minTime, minTime = _h === void 0 ? (0, date_fns_1.isSameDay)(minDateTime, selected || new Date())
        ? minDateTime
        : (0, date_fns_1.isBefore)(selected || new Date(), minDateTime)
            ? MAX_DATE
            : MIN_DATE : _h, _j = _a.maxDateTime, maxDateTime = _j === void 0 ? MAX_DATE : _j, _k = _a.maxDate, maxDate = _k === void 0 ? maxDateTime : _k, _l = _a.maxTime, maxTime = _l === void 0 ? (0, date_fns_1.isSameDay)(maxDateTime, selected || new Date())
        ? maxDateTime
        : (0, date_fns_1.isAfter)(selected || new Date(), maxDateTime)
            ? MIN_DATE
            : MAX_DATE : _l, rest = __rest(_a, ["className", "id", "selected", "error", "onChange", "dateFormat", "timeFormat", "isClearable", "minDateTime", "minDate", "minTime", "maxDateTime", "maxDate", "maxTime"]);
    var safeOnChange = (0, react_1.useCallback)(function (date) {
        if (date || isClearable) {
            onChange(date);
        }
    }, [isClearable, onChange]);
    var CustomInput = (0, react_1.forwardRef)(function (_a, _) {
        var className = _a.className, restProps = __rest(_a, ["className"]);
        return (react_1["default"].createElement(Form_1.Input, __assign({}, restProps, { className: (0, classnames_1["default"])({ 'input-error': error }, className) })));
    });
    return (react_1["default"].createElement("div", { className: (0, classnames_1["default"])('vs-datetimepicker', className) },
        react_1["default"].createElement(react_datepicker_1["default"], __assign({ showTimeSelect: true, id: id, selected: selected, onChange: safeOnChange, onSelect: safeOnChange, dateFormat: dateFormat, timeFormat: timeFormat, isClearable: isClearable, minDate: minDate, minTime: minTime, maxDate: maxDate, maxTime: maxTime, customInput: react_1["default"].createElement(CustomInput, null) }, rest))));
};
exports.DateTimePicker = DateTimePicker;
